@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/master-kush-strain-index-card-stack-content/master-kush-strain-index-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
:host .main-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  padding: 0.25rem;
}
:host .main-content .logo-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  height: 8rem;
}
:host .main-content .logo-container .brand-logo {
  max-width: 100%;
  max-height: 5.625rem;
}
:host .main-content .logo-container .product-card-brand {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: normal;
  font-size: 2rem;
  text-align: center;
}
:host .main-content .product-info-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}
:host .main-content .product-info-container .product-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  align-self: stretch;
}
:host .main-content .product-info-container .product-info .title-quantity-and-unit-size {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  align-self: stretch;
}
:host .main-content .product-info-container .product-info .title-quantity-and-unit-size .product-card-title {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
:host .main-content .product-info-container .product-info .title-quantity-and-unit-size .product-card-size {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 0.8125rem;
}
:host .main-content .product-info-container .pricing-container {
  position: relative;
}
:host .main-content .product-info-container .strain-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  margin-top: 1rem;
}
:host .main-content .product-info-container .strain-info .product-card-individual-product-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
}
:host .main-content .product-info-container .strain-info .plus-n-more-strains {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: italic;
  font-size: 0.6875rem;
  line-height: 100%;
  letter-spacing: -0.11px;
}
/*# sourceMappingURL=master-kush-strain-index-card-stack-content.component.css.map */
